/**
 * 计算视频时长
 * @param {Number} duration 视频时长 秒
 * @return {String} 格式化的时间00:00:00 / 00:00
 */
const formatVideoDuration = duration => {
    let second = parseInt(duration);
    let minute = 0;
    let hour = 0;
    let formatedDuration = '';

    if (second >= 60) {
        minute = parseInt(second / 60);
        second = parseInt(second % 60);
        if (minute >= 60) {
            hour = parseInt(minute / 60);
            minute = parseInt(minute % 60);
        }
    }

    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;
    hour = hour < 10 ? `0${hour}` : hour;

    if (parseInt(duration) < 60) {
        formatedDuration = `00:${second}`;
    }

    if (minute > 0) {
        formatedDuration = `${minute}:${second}`;
    }

    if (hour > 0) {
        formatedDuration = `${hour}:${minute}:${second}`;
    }

    return formatedDuration;
};

export default formatVideoDuration;
